var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.handleTabs($event)}}},[_vm._l((_vm.list),function(item){return [_c('span',{key:item.id,class:_vm.id===item.id?'active':'',attrs:{"id":item.id}},[_vm._v(_vm._s(item.factoryName))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }